import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '@/hooks/useRefreshToken';
import useAuth from '@/hooks/useAuth';
import useLocalStorage from "../hooks/useLocalStorage";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const auth = useAuth();
  const [persist] = useLocalStorage('persist', true);

  if (!auth) {
    return <></>
  }

  const { user } = auth;

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        const accessToken = await refresh();
        console.log('[PersistLogin accessToken]', accessToken);
      } catch (err) {
        console.error(err);
      }
      finally {
        isMounted && setIsLoading(false);
      }
    }

    !user?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

    return () => { isMounted = false; }
  }, []);


  return (
    <>
      {!persist
        ? <Outlet />
        : isLoading
          ? <p>Loading...</p>
          : <Outlet />
      }
    </>
  )
}

export default PersistLogin;
